import { useRouteLoaderData } from "react-router";
import { type loader as rootLoader } from "~/root";
import { User } from "../db/schema";

export const getFallbackGradient = () => {
  const randomAngle = () => Math.round(Math.random() * 360);
  const getRandomColor = () => `hsl(${Math.random() * 360}, 100%, 75%)`;

  const gradient1 = `linear-gradient(${randomAngle()}deg, ${getRandomColor()}, ${getRandomColor()})`;
  const gradient2 = `linear-gradient(${randomAngle()}deg, ${getRandomColor()}, ${getRandomColor()})`;
  return `${gradient1}, ${gradient2}`;
};

function isUser(user: any): user is User {
  return user && typeof user === "object" && "id" in user && "profile" in user;
}

export function useOptionalUser() {
  const data = useRouteLoaderData<typeof rootLoader>("root");
  if (!data || !isUser(data.user)) {
    return undefined;
  }
  return data.user as User & {
    profile: NonNullable<User["profile"]>;
  };
}

export function useUser() {
  const maybeUser = useOptionalUser();
  if (!maybeUser) {
    throw new Error(
      "No user found in root loader, but user is required by useUser. If user is optional, try useOptionalUser instead."
    );
  }
  return maybeUser;
}

export function useTeam() {
  const data = useRouteLoaderData<typeof rootLoader>("root");
  if (!data) {
    return undefined;
  }
  return data.team;
}
